var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = "/monitoring";
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"_iTu4p2Uqeo2ggAkCK9pq"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs'

const isDev = process.env.NODE_ENV !== 'production'

type ExtraSentryError =
  | {
      error?: {
        message: string
      }
    }
  | undefined

Sentry.init({
  dsn: 'https://6252f1094a55ae20799630e49a2b46cb@o489437.ingest.sentry.io/4505957386223616',

  // Called for message and error events
  beforeSend(event) {
    // Modify or drop the event here
    const extraErrorMessage = (event.extra?.__serialized__ as ExtraSentryError)?.error?.message

    const ignoredEvents = ['Failed to fetch', 'Load failed', 'Network request failed', 'annulé', 'NetworkError when attempting to fetch resource.', 'avbruten']

    if (extraErrorMessage && ignoredEvents.includes(extraErrorMessage)) {
      return null
    }

    return event
  },

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: isDev ? false : false,

  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    new Sentry.Replay({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true
    })
  ],

  environment: process.env.NODE_ENV
})
